import axios, {
  AxiosInstance,
  InternalAxiosRequestConfig,
  AxiosResponse,
  AxiosError,
} from "axios";
import { toast } from "react-toastify";

const API_BASE_URL = process.env.REACT_APP_API_URL;

const http: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// 1. REQUEST INTERCEPTOR: To add the Authorization header
http.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    } else {
      console.log(
        "Request Interceptor: No token found in localStorage",
        config.url
      );
    }
    return config;
  },
  (error: AxiosError) => {
    console.error("Axios Request Interceptor Error:", error);
    return Promise.reject(error);
  }
);

// 2. RESPONSE INTERCEPTOR: To handle global errors like 401
http.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError) => {
    console.error(
      "Axios Response Interceptor Error:",
      error.response?.status,
      error.config?.url,
      error.response?.data
    );

    if (error.response) {
      const { status, data } = error.response;

      if (status === 401) {
        console.warn(
          "Response Interceptor (401): Unauthorized access. Logging out.",
          error.config?.url
        );
        if (window.location.pathname !== "/login") {
          const publicPaths = [
            "/login",
            "/forgot-password",
            "/otp-verification",
            "/apply",
            "/onboard",
            "/privacy-policy",
          ];
          const isPublic = publicPaths.some(
            (p) =>
              window.location.pathname === p ||
              window.location.pathname.startsWith(`${p}/`)
          );
          if (!isPublic) {
            localStorage.removeItem("token");
            window.location.href = "/login";
            toast.error("Session expired or invalid. Please log in again.");
          }
        }
      } else if (status === 403) {
        toast.error(
          (data as any)?.message ||
            "You do not have permission to perform this action."
        );
      } else if (status === 404) {
      } else if (status === 500) {
        toast.error(
          (data as any)?.message || "An unexpected server error occurred."
        );
      }
    } else if (error.request) {
      console.error("Network Error or No Response:", error.request);
      toast.error("Network error. Please check your connection.");
    } else {
      console.error("Axios Error on Request Setup:", error.message);
      toast.error("An error occurred while sending the request.");
    }
    return Promise.reject(error);
  }
);

export { http };
